import React from 'react';
import Interview2023 from 'views/Literaryclub2023/Interview2023';
const LifeSkillPage = () => {
  return <Interview2023/>;
};
export default LifeSkillPage;